import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Tooltip.less';

// to move the tooltip around, add custom styling to the classname `zola-tooltip__container` or pass in your own classname;
const Tooltip = ({ text, boldText, className, visible, width = 200 }) => (
  <div
    className={classNames(
      'zola-tooltip__container',
      className
    )}
  >
    <div
      style={{ width }}
      className={classNames(
        'zola-tooltip',
        { hidden: !visible }
      )}
    >
      { text }
      <span className="bold">{ boldText }</span>
    </div>
  </div>
);

Tooltip.propTypes = {
  text: PropTypes.string,
  boldText: PropTypes.string,
  className: PropTypes.string,
  visible: PropTypes.bool,
  width: PropTypes.number
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/common/ui/Tooltip/Tooltip.jsx